// class ShopifyAPI {
//     constructor(url, accessToken) {
//       this.url = url;
//       this.accessToken = accessToken;
//     }
  
//     async updateCartDiscountCodes(cartId, discountCodes) {
//       const data = {
//         query: `
//           mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
//             cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
//               cart {
//                 discountCodes {
//                   code
//                   applicable
//                 }
//                 discountAllocations {
//                   discountedAmount {
//                     amount
//                     currencyCode
//                   }
//                 }
//                 cost {
//                   subtotalAmount {
//                     amount
//                     currencyCode
//                   }
//                 }
//               }
//             }
//           }
//         `,
//         variables: {
//           cartId: 'gid://shopify/Cart/' + cartId,
//           discountCodes: discountCodes
//         }
//       };
//       debugger
//       const options = {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Shopify-Storefront-Access-Token': this.accessToken
//         },
//         body: JSON.stringify(data)
//       };
  
//       try {
//         const response = await fetch(this.url, options);
//         const responseData = await response.json();
//         return responseData;
//       } catch (error) {
//         console.error('Erro:', error);
//         throw new Error('Erro ao fazer requisição à API Shopify');
//       }
//     }
//   }
  


//   document.addEventListener("DOMContentLoaded", async function() {
//     window.discountCodesFunction = function() {
//       let removeCouponTimeout;

//       // token app store - generate in your store admin:  
//       // APPS/ development apps/ API Storefront / scope: unauthenticated_read_checkouts
//       const shopifyAccessToken = "00a32bdd3fa526679e6f809b7b7b4aa9";
//       const shopifyUrl = "https://lojasublyme.myshopify.com"; //url domain
      

//       const shopifyUrlApi = shopifyUrl + "/api/2024-04/graphql.json";
//       const shopifyAPI = new ShopifyAPI(shopifyUrlApi, shopifyAccessToken);

//       // remove and add coupons
//       async function updateCoupons(coupons, isRemoveAction) {
//           try {
//               const cartResponse = await fetch('/cart.js');
//               const cartData = await cartResponse.json();
//               const cartId = cartData.token;
      
//               const result = await shopifyAPI.updateCartDiscountCodes(cartId, coupons);
//               //if page cart
//               if (window.location.href.indexOf("/cart") > -1) {
//                 setTimeout(function() {
//                     window.location.reload();
//                 }, 1200);
//               }
      
//               //Verify if all added coupons are valid.
//               let allApplicable = true;
//               for (let i = 0; i < result.data.cartDiscountCodesUpdate.cart.discountCodes.length; i++) {
//                   if (!result.data.cartDiscountCodesUpdate.cart.discountCodes[i].applicable) {
//                       allApplicable = false;
//                       break;
//                   }
//               }
      
//               if (allApplicable) {
//                   if (isRemoveAction) {
//                       document.querySelector('.drawer__coupon .error').innerHTML = 'CUPOM REMOVIDO';  //message remove coupon
//                   } else {
//                       document.querySelector('.drawer__coupon .success').innerHTML = 'CUPOM APLICADO';  //message apply coupon
//                       document.querySelector('.drawer__coupon-input').value = '';
//                   }

//                   fetch(shopifyUrl)
//                       .then(response => {
//                           if (response.ok) {
//                               return response.text();
//                           }
//                           throw new Error('Erro ao carregar o carrinho.');
//                       })
//                       .then(html => {
//                           const tempElement = document.createElement('div');
//                           tempElement.innerHTML = html;
//                           const cartItemsDiv = tempElement.querySelector('#CartDrawer-CartItems');//container cart
//                           if (cartItemsDiv) {
//                               document.querySelector('#CartDrawer-CartItems').innerHTML = cartItemsDiv.innerHTML;//container cart
//                               const totalCart = result.data.cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount;
//                               document.querySelector('.totals__total-value').textContent = formatCurrency(totalCart); //update total cart DOM
//                           } else {
//                               throw new Error('Div #CartDrawer-CartItems não encontrada no HTML retornado.');
//                           }
//                           triggerUpdateCoupon();
//                           document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
//                           document.querySelector('.remove-coupon').removeAttribute('disabled');
//                       })
//                       .catch(error => {
//                           console.error('Erro:', error);
//                           document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
//                           document.querySelector('.remove-coupon').removeAttribute('disabled');
//                       });
//               } else {
//                   document.querySelector('.drawer__coupon .error').textContent = 'CUPOM INVÁLIDO!'; //message invalid coupon
//                   document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
//                   document.querySelector('.remove-coupon').removeAttribute('disabled');
//               }
//           } catch (error) {
//               console.error(error.message);
//               document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
//               document.querySelector('.remove-coupon').removeAttribute('disabled');
//           }
//       }
      
      
      
//       async function updateCouponAction(couponValue, isRemoveAction) {
//           document.querySelector('.drawer__coupon .success').innerHTML = '';
//           document.querySelector('.drawer__coupon .error').innerHTML = '';
//           try {
//               const appliedCoupons = Array.from(document.querySelectorAll('.applied_coupon'))
//                                           .map(couponElement => couponElement.textContent.trim());
//               if (isRemoveAction) {
//                   const updatedCoupons = appliedCoupons.filter(coupon => coupon !== couponValue);
//                   await updateCoupons(updatedCoupons, true);
//               } else {
//                   const updatedCoupons = [...appliedCoupons, couponValue];
//                   await updateCoupons(updatedCoupons, false);
//               }
//           } catch (error) {
//               console.error(error.message);
//           }
//       }
      
//       // Event listener remove coupon
//       function triggerUpdateCoupon(){
//           document.querySelectorAll('.remove-coupon').forEach(button => {
//               button.addEventListener('click', function() {
//                   this.setAttribute('disabled', true);
//                   const couponToRemove = this.dataset.coupon;
//                   updateCouponAction(couponToRemove, true); 
//               });
//           });
          
//           // Apply coupon
//           async function applyCoupon() {
//             document.querySelector('.drawer__coupon-btn').setAttribute('disabled', true);
//             const couponInput = document.querySelector('.drawer__coupon-input');
//             const couponValue = couponInput.value.trim();
//             updateCouponAction(couponValue, false);
//           }

//           document.querySelector('.drawer__coupon-btn').addEventListener('click', applyCoupon);
//           document.querySelector('.drawer__coupon-input').addEventListener('keypress', async function(event) {
//             if (event.key === 'Enter') {
//                 applyCoupon();
//             }
//           });
//       }
//       triggerUpdateCoupon()

//       function formatCurrency(value) {
//           // Converte o valor para número
//           const numberValue = parseFloat(value);
          
//           // Verifica se o valor é um número válido
//           if (isNaN(numberValue)) {
//               return 'Valor inválido';
//           }
          
//           // Formata o número para a moeda brasileira (BRL)
//           const formattedValue = numberValue.toLocaleString('pt-BR', {
//               style: 'currency',
//               currency: 'BRL',
//               minimumFractionDigits: 2
//           });
          
//           return formattedValue;
//       }
//     }
//     window.discountCodesFunction()
    
// });


class ShopifyAPI {
  constructor(url, accessToken) {
    this.url = url;
    this.accessToken = accessToken;
  }

  async updateCartDiscountCodes(cartId, discountCodes) {
    const data = {
      query: `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
              discountCodes {
                code
                applicable
              }
              discountAllocations {
                discountedAmount {
                  amount
                  currencyCode
                }
              }
              cost {
                subtotalAmount {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      `,
      variables: {
        cartId: 'gid://shopify/Cart/' + cartId,
        discountCodes: discountCodes
      }
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.accessToken
      },
      body: JSON.stringify(data)
    };

    try {
      const response = await fetch(this.url, options);
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Erro:', error);
      throw new Error('Erro ao fazer requisição à API Shopify');
    }
  }
}



document.addEventListener("DOMContentLoaded", async function() {
  window.discountCodesFunction = function() {
    let removeCouponTimeout;

    // token app store - generate in your store admin:  
    // APPS/ development apps/ API Storefront / scope: unauthenticated_read_checkouts
    const shopifyAccessToken = "";
    const shopifyUrl = ""; //url domain
    

    const shopifyUrlApi = shopifyUrl + "/api/2024-04/graphql.json";
    const shopifyAPI = new ShopifyAPI(shopifyUrlApi, shopifyAccessToken);

    // remove and add coupons
    async function updateCoupons(coupons, isRemoveAction) {
        try {
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            const cartId = cartData.token;
    
            const result = await shopifyAPI.updateCartDiscountCodes(cartId, coupons);

            //if page cart
            if (window.location.href.indexOf("/cart") > -1) {
              setTimeout(function() {
                  window.location.reload();
              }, 1200);
            }
    
            //Verify if all added coupons are valid.
            let allApplicable = true;
            for (let i = 0; i < result.data.cartDiscountCodesUpdate.cart.discountCodes.length; i++) {
                if (!result.data.cartDiscountCodesUpdate.cart.discountCodes[i].applicable) {
                    allApplicable = false;
                    break;
                }
            }
    
            if (allApplicable) {
                if (isRemoveAction) {
                    document.querySelector('.drawer__coupon .error').innerHTML = 'CUPOM REMOVIDO';  //message remove coupon
                } else {
                    document.querySelector('.drawer__coupon .success').innerHTML = 'CUPOM APLICADO';  //message apply coupon
                    document.querySelector('.drawer__coupon-input').value = '';
                }

                fetch(shopifyUrl)
                .then(response => {
                    if (response.ok) {
                        return response.text();
                    }
                    throw new Error('Erro ao carregar o carrinho.');
                })
                .then(html => {
                    const tempElement = document.createElement('div');
                    tempElement.innerHTML = html;

                    const selectors = ['#CartDrawer-CartItems', 'cart-drawer-items', '.cart-drawer__footer'];

                    selectors.forEach(selector => {
                        const newContent = tempElement.querySelector(selector);
                        if (newContent) {
                            const currentElement = document.querySelector(selector);
                            if (currentElement) {
                                currentElement.innerHTML = newContent.innerHTML;
                                window.discountCodesFunction();
                                window.showShippingCalculator();
                                window.updateFreeGiftProgressBar();
                                window.ShippingCalculator.init();
                            } else {
                                throw new Error(`Elemento ${selector} não encontrado no DOM atual.`);
                            }
                        } else {
                            throw new Error(`Div ${selector} não encontrada no HTML retornado.`);
                        }
                    });

                    const totalCart = result.data.cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount;
                    document.querySelector('.totals__total-value').textContent = formatCurrency(totalCart); // Atualiza o total do carrinho no DOM

                    triggerUpdateCoupon();
                    document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
                    document.querySelector('.remove-coupon').removeAttribute('disabled');
                })
                .catch(error => {
                    console.error('Erro:', error);
                    document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
                    document.querySelector('.remove-coupon').removeAttribute('disabled');
                });
            } else {
                document.querySelector('.drawer__coupon .error').textContent = 'CUPOM INVÁLIDO!'; //message invalid coupon
                document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
                document.querySelector('.remove-coupon').removeAttribute('disabled');
            }
        } catch (error) {
            console.error(error.message);
            document.querySelector('.drawer__coupon-btn').removeAttribute('disabled');
            document.querySelector('.remove-coupon').removeAttribute('disabled');
        }
    }
    
    
    
    async function updateCouponAction(couponValue, isRemoveAction) {
        document.querySelector('.drawer__coupon .success').innerHTML = '';
        document.querySelector('.drawer__coupon .error').innerHTML = '';
        try {
            const appliedCoupons = Array.from(document.querySelectorAll('.applied_coupon'))
                                        .map(couponElement => couponElement.textContent.trim());
            if (isRemoveAction) {
                const updatedCoupons = appliedCoupons.filter(coupon => coupon !== couponValue);
                await updateCoupons(updatedCoupons, true);
            } else {
                const updatedCoupons = [...appliedCoupons, couponValue];
                await updateCoupons(updatedCoupons, false);
            }
        } catch (error) {
            console.error(error.message);
        }
    }
    
    // Event listener remove coupon
    function triggerUpdateCoupon(){
        document.querySelectorAll('.remove-coupon').forEach(button => {
            button.addEventListener('click', function() {
                this.setAttribute('disabled', true);
                const couponToRemove = this.dataset.coupon;
                updateCouponAction(couponToRemove, true); 
            });
        });
        
        // Apply coupon

        const couponBtn = document.querySelector('.drawer__coupon-btn');
        if (couponBtn) {

          async function applyCoupon() {
            couponBtn.setAttribute('disabled', true);
            const couponInput = document.querySelector('.drawer__coupon-input');
            const couponValue = couponInput.value.trim();
            updateCouponAction(couponValue, false);
          }

          
          couponBtn.addEventListener('click', applyCoupon);
          document.querySelector('.drawer__coupon-input').addEventListener('keypress', async function(event) {
            if (event.key === 'Enter') {
                applyCoupon();
            }
          });
        }
    }
    triggerUpdateCoupon()

    function formatCurrency(value) {
        // Converte o valor para número
        const numberValue = parseFloat(value);
        
        // Verifica se o valor é um número válido
        if (isNaN(numberValue)) {
            return 'Valor inválido';
        }
        
        // Formata o número para a moeda brasileira (BRL)
        const formattedValue = numberValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        });
        
        return formattedValue;
    }
  }
  window.discountCodesFunction()
  
});
